import {Injectable} from '@angular/core';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons';
import {
  faCalendarAlt,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faExternalLink,
  faGlobe,
  faMapMarkerAlt,
  faMoneyBillWave,
  faPen,
  faSliders,
  faSuitcase,
  faTimes,
  faTimesCircle,
  faUser,
} from '@fortawesome/pro-regular-svg-icons';
import {faExternalLinkAlt} from '@fortawesome/pro-solid-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class FontawesomeService {
  public readonly regular = {
    calendarAlt: faCalendarAlt,
    chevronLeft: faChevronLeft,
    chevronRight: faChevronRight,
    chevronUp: faChevronUp,
    chevronDown: faChevronDown,
    clock: faClock,
    externalLink: faExternalLink,
    globe: faGlobe,
    mapMarkerAlt: faMapMarkerAlt,
    moneyBillWave: faMoneyBillWave,
    suitcase: faSuitcase,
    timesCircle: faTimesCircle,
    times: faTimes,
    sliders: faSliders,
    pen: faPen,
    user: faUser,
  };
  public readonly solid = {
    externalLinkAlt: faExternalLinkAlt,
  };
  public readonly brands = {
    linkedin: faLinkedin,
  };
}
